/* eslint-disable react/no-danger */
import React from 'react';
import { isEmpty, kebabCase } from 'lodash';
import { motion } from 'framer-motion';
import BoxedContainer from '../layouts/BoxedContainer';
import Button from '../layouts/Button';

export default function IntroTextWithCard({ data }) {
  const { introTitle, introText, linksButtons, cardTitle, cardText, cardPrice } = data;
  return (
    <section className="lg:pt-[180px] pt-[80px] pb-[20px] lg:-mt-[80px] -mt-[20px]">
      <BoxedContainer className="regular">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.6 }}
          viewport={{ once: true }}
          className="flex md:flex-row flex-col md:gap-x-[70px] md:gap-y-0 gap-y-[35px]"
        >
          <div className="flex flex-col md:gap-y-[58px] gap-y-[20px] 2xl:w-[54%] md:w-[59%]">
            <div className="flex flex-col md:gap-y-[26px] gap-y-[15px]">
              {isEmpty(introTitle) || (
                <h3
                  className="text-primary font-roboto-condensed-bold lg:text-2xl md:text-[35px]
                text-[28px] md:leading-[48px] leading-9 uppercase"
                >
                  {introTitle}
                </h3>
              )}
              {isEmpty(introText) || (
                <div
                  dangerouslySetInnerHTML={{ __html: introText }}
                  className="text-primary lg:text-base text-[15px] leading-7 flex flex-col
                  md:gap-y-4 gap-y-2 font-roboto-regular"
                />
              )}
            </div>
            <div className="flex flex-row gap-x-[20px]">
              {isEmpty(linksButtons) ||
                linksButtons.map((item, index) => (
                  <div key={index}>
                    <Button
                      url={item.url}
                      label={item.name}
                      ariaLabel={item.name}
                      tagName={kebabCase(item.name)}
                      text="md:!px-8 !px-2"
                      variant={index === 0 ? 'primaryRed' : 'secondaryRed'}
                    />
                  </div>
                ))}
            </div>
          </div>
          {isEmpty(cardTitle) || (
            <div className="md:w-[270px] h-[120px] bg-bg-1 lg:mt-[160px] ,md:mt-[128px]">
              <h3
                className="font-roboto-condensed-bold bg-bg-10 h-[40px] text-white uppercase
                    flex items-center px-[20px] text-[16px] leading-[24px]"
              >
                {cardTitle}
              </h3>
              <div
                className="flex flex-row justify-between items-center bg-bg-1 px-[20px]
              h-[80px]"
              >
                <p className="font-roboto-regular text-primary text-[16px] leading-[24px]">
                  {cardText}
                </p>
                <p className="font-roboto-bold text-red text-base uppercase">{cardPrice}</p>
              </div>
            </div>
          )}
        </motion.div>
      </BoxedContainer>
    </section>
  );
}
